var React = require('react');

function DocumentPound12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10 12V2.5L7.5 0H2V12H10ZM5.60114 9H8V10H4V9C4.25107 9 4.40642 8.92144 4.52037 8.81172C4.64694 8.68983 4.75368 8.49768 4.83359 8.23133C4.94736 7.85209 4.98339 7.40836 4.99477 7H4V6H4.87167C4.80124 5.85777 4.70373 5.70699 4.58397 5.52735L4.56246 5.49512C4.32462 5.13898 4 4.6529 4 4C4 2.89543 4.89543 2 6 2C7.10457 2 8 2.89543 8 4H7C7 3.44772 6.55229 3 6 3C5.44772 3 5 3.44772 5 4C5 4.32719 5.15527 4.58152 5.41603 4.97265L5.43754 5.00488C5.61019 5.26341 5.82858 5.59041 5.93531 6H7V7H5.99549C5.98379 7.45695 5.94179 8.01743 5.79141 8.51867C5.7431 8.6797 5.68131 8.84309 5.60114 9Z","fill":"currentColor"}));
}

DocumentPound12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = DocumentPound12;

DocumentPound12.default = DocumentPound12;
